import React from "react";
type AppProps = {
  salaryDetails: any;
  inputDetailsError: any;
  handleBasicDetailsInput: (data: any, section: string, name: string) => void;
};
const SalaryDetails = ({
  salaryDetails,
  inputDetailsError,
  handleBasicDetailsInput,
}: AppProps) => {
  return (
    <>
      <div className="mb-2 mt-5">
        <h5
          style={{ marginBottom: "20px", fontSize: "15px", fontWeight: "600" }}
        >
          SALARY DETAILS
        </h5>
      </div>
      <div className="row">
        <div className="col-md-3">
          <label className="mb-1" htmlFor="firstName">
            Current (Annual) CTC
          </label>
          <div>
            <input
              type="number"
              onWheel={(event) => event.currentTarget.blur()}
              className={`form-control ${
                inputDetailsError?.currentTotalCtcError ? "error-border" : ""
              }`}
              name="currentTotalCtc"
              onChange={(e) =>
                handleBasicDetailsInput(e, "salaryDetails", "currentTotalCtc")
              }
              value={salaryDetails?.currentTotalCtc}
              // disabled={isDisabled}
            />
            {/* {!!inputDetailsError?.currentTotalCtcError && (
              <small className="text-danger">
                {inputDetailsError?.currentTotalCtcError}
              </small>
            )} */}
          </div>
        </div>
        {
          <>
            <div className="col-md-3">
              <label className="mb-1" htmlFor="firstName">
                Current Fixed (Annual) CTC
              </label>
              <div>
                <input
                  type="number"
                  onWheel={(event) => event.currentTarget.blur()}
                  className={`form-control ${
                    inputDetailsError?.currentFixedCtcError
                      ? "error-border"
                      : ""
                  }`}
                  name="current_fixed_ctc"
                  onChange={(e) =>
                    handleBasicDetailsInput(
                      e,
                      "salaryDetails",
                      "currentFixedCtc"
                    )
                  }
                  value={salaryDetails?.current_fixed_ctc}
                  // disabled={isDisabled}
                />
                {/* {!!inputDetailsError?.currentFixedCtcError && (
                  <small className="text-danger">
                    {inputDetailsError?.currentFixedCtcError}
                  </small>
                )} */}
              </div>
            </div>
            <div className="col-md-3">
              <label className="mb-1" htmlFor="lastName">
                Minimum Expected (Annual) CTC
              </label>
              <div>
                <input
                  type="number"
                  onWheel={(event) => event.currentTarget.blur()}
                  // className="form-control"
                  className={`form-control ${
                    inputDetailsError?.minExpectedTotalCtcError
                      ? "error-border"
                      : ""
                  }`}
                  name="min_expected_total_ctc"
                  // onChange={handleBasicDetailsInput(e,"salaryDetails")}
                  onChange={(e) =>
                    handleBasicDetailsInput(
                      e,
                      "salaryDetails",
                      "minExpectedTotalCtc"
                    )
                  }
                  value={salaryDetails?.min_expected_total_ctc}
                  // disabled={isDisabled}
                />
                {/* {!!inputDetailsError?.minExpectedTotalCtcError && (
                  <small className="text-danger">
                    {inputDetailsError?.minExpectedTotalCtcError}
                  </small>
                )} */}
              </div>
            </div>
          </>
        }
        <div className="col-md-3">
          <label className="mb-1" htmlFor="name">
            Minimum Expected Fixed (Annual) CTC
          </label>
          <div>
            <input
              type="number"
              onWheel={(event) => event.currentTarget.blur()}
              className={`form-control ${
                inputDetailsError?.minExpectedFixedCtcError
                  ? "error-border"
                  : ""
              }`}
              name="min_expected_fixed_ctc"
              // onChange={handleBasicDetailsInput}
              onChange={(e) =>
                handleBasicDetailsInput(
                  e,
                  "salaryDetails",
                  "minExpectedFixedCtc"
                )
              }
              value={salaryDetails?.min_expected_fixed_ctc}
            />
            {/* {!!inputDetailsError?.minExpectedFixedCtcError && (
              <small className="text-danger">
                {inputDetailsError?.minExpectedFixedCtcError}
              </small>
            )} */}
          </div>
        </div>
        <div className="col-md-3" style={{marginTop: "20px"}}>
          <label className="mb-1" htmlFor="name">
            Offered (Annual) CTC
          </label>
          <div>
            <input
              type="number"
              onWheel={(event) => event.currentTarget.blur()}
              className={`form-control ${
                inputDetailsError?.minExpectedFixedCtcError
                  ? "error-border"
                  : ""
              }`}
              name="offered_annual_ctc"
              // onChange={handleBasicDetailsInput}
              onChange={(e) =>
                handleBasicDetailsInput(
                  e,
                  "salaryDetails",
                  "offeredAnnualCtc"
                )
              }
              value={salaryDetails?.offered_annual_ctc}
            />
            {/* {!!inputDetailsError?.minExpectedFixedCtcError && (
              <small className="text-danger">
                {inputDetailsError?.minExpectedFixedCtcError}
              </small>
            )} */}
          </div>
        </div>
        <div className="col-md-3" style={{marginTop: "20px"}}>
          <label className="mb-1" htmlFor="name">
            Offered Fixed (Annual) CTC
          </label>
          <div>
            <input
              type="number"
              onWheel={(event) => event.currentTarget.blur()}
              className={`form-control ${
                inputDetailsError?.minExpectedFixedCtcError
                  ? "error-border"
                  : ""
              }`}
              name="offered_fixed_annual_ctc"
              // onChange={handleBasicDetailsInput}
              onChange={(e) =>
                handleBasicDetailsInput(
                  e,
                  "salaryDetails",
                  "offeredFixedAnnualCtc"
                )
              }
              value={salaryDetails?.offered_fixed_annual_ctc}
            />
            {/* {!!inputDetailsError?.minExpectedFixedCtcError && (
              <small className="text-danger">
                {inputDetailsError?.minExpectedFixedCtcError}
              </small>
            )} */}
          </div>
        </div>
      </div>
    </>
  );
};

export default SalaryDetails;
